import { createContext, useContext } from 'react'

export interface OpenExplainerOptions {
  /**
   * Whether the fix action is relevant. Pass `false` when the term is already in
   * good shape (a high-scoring dimension, a passing gate) so the modal hides its
   * "fix it" CTA — there is nothing to fix.
   */
  showAction?: boolean
}

export interface ScoreExplainerContextValue {
  /** Open the explainer modal for a fully-qualified term id (e.g. "static.hook"). */
  openExplainer: (id: string, opts?: OpenExplainerOptions) => void
}

export const ScoreExplainerContext = createContext<ScoreExplainerContextValue | null>(null)

const NOOP: ScoreExplainerContextValue = { openExplainer: () => {} }

/**
 * Hook for scorecard sub-components (dimension labels, gate chips, the verdict
 * pill) to open the explainer modal. Returns a no-op opener outside a provider so
 * the components stay usable in isolation.
 */
export function useScoreExplainer(): ScoreExplainerContextValue {
  return useContext(ScoreExplainerContext) ?? NOOP
}
